import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import CompactToggle from '~/components/toolbar/shared/CompactToggle';
import { lineOptionsState } from '~/state/atoms/toolsAtoms';

export default function LineToolOptions() {
    const [lineOptions, setLineOptions] = useRecoilState(lineOptionsState);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
            }}
        >
            <CompactToggle
                labelId="toolbar.contouring.erase"
                tooltipId="toolbar.contouring.erase.tooltip"
                value={lineOptions.mode === 'erase'}
                onChange={(erase) =>
                    setLineOptions((options) => ({
                        ...options,
                        mode: erase ? 'erase' : 'draw',
                    }))
                }
            />
        </Box>
    );
}
